import React, { useState, useEffect } from 'react';
import api from '../../api';
import { FaCogs, FaSave, FaTrash, FaPlus, FaEdit, FaClipboardCheck, FaHandshake, FaShoppingCart, FaHardHat, FaTools } from 'react-icons/fa';
import styles from './Admin.module.css';

const AdminProcessSteps = () => {
  const [steps, setSteps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  // Form State
  const [form, setForm] = useState({
    id: 0,
    stepNumber: '',
    title: '',
    description: '',
    duration: '',
    iconName: 'FaClipboardCheck',
    displayOrder: 0
  });

 

  // Icon Options for Dropdown
  const iconOptions = [
    "FaClipboardCheck", "FaHandshake", "FaCogs", 
    "FaShoppingCart", "FaHardHat", "FaTools"
  ];

  useEffect(() => {
    fetchSteps();
  }, []);

  const fetchSteps = async () => {
    try {
      const res = await api.get('/ProcessSteps');
      setSteps(res.data);
    } catch (err) {
      console.error("Error fetching steps", err);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      // Auto-set display order if new
      const payload = { ...form, displayOrder: form.id === 0 ? steps.length + 1 : form.displayOrder };
      
     await api.post('/ProcessSteps/save', payload);
      
      setMessage({ text: "Step Saved Successfully!", type: "success" });
      fetchSteps();
      resetForm();
    } catch (err) {
      setMessage({ text: "Error saving step", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this step?")) return;
    try {
      const token = localStorage.getItem('token');
     await api.delete(`/ProcessSteps/delete/${id}`);
      fetchSteps();
    } catch (err) {
      alert("Error deleting step");
    }
  };

  const handleEdit = (step) => {
    setForm(step);
    window.scrollTo(0, 0); // Scroll to form
  };

  const resetForm = () => {
    setForm({
      id: 0,
      stepNumber: String(steps.length + 1).padStart(2, '0'), // Auto-suggest next number like "07"
      title: '',
      description: '',
      duration: '',
      iconName: 'FaClipboardCheck',
      displayOrder: 0
    });
  };

  return (
    <div className={styles.formCard} style={{ maxWidth: '900px' }}>
      <h3 style={{ marginBottom: '1.5rem', color: '#4ade80', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <FaCogs /> Manage Process Steps
      </h3>

      {/* Message Alert */}
      {message.text && (
        <div style={{
          padding: '10px', marginBottom: '20px', borderRadius: '5px',
          background: message.type === 'error' ? 'rgba(239,68,68,0.2)' : 'rgba(74,222,128,0.2)',
          color: message.type === 'error' ? '#fca5a5' : '#4ade80'
        }}>
          {message.text}
        </div>
      )}

      {/* --- FORM SECTION --- */}
      <form onSubmit={handleSubmit} style={{ marginBottom: '30px', paddingBottom: '20px', borderBottom: '1px solid #444' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '100px 1fr', gap: '15px', marginBottom: '15px' }}>
          <div className={styles.formGroup}>
            <label>Number</label>
            <input 
              className={styles.formInput} 
              name="stepNumber" 
              placeholder="01" 
              value={form.stepNumber} 
              onChange={handleChange} 
              required 
            />
          </div>
          <div className={styles.formGroup}>
            <label>Title</label>
            <input 
              className={styles.formInput} 
              name="title" 
              placeholder="e.g. Site Survey" 
              value={form.title} 
              onChange={handleChange} 
              required 
            />
          </div>
        </div>

        <div className={styles.formGroup}>
          <label>Description</label>
          <textarea 
            className={styles.formInput} 
            name="description" 
            placeholder="Step details..." 
            value={form.description} 
            onChange={handleChange} 
            rows="2" 
            required 
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
          <div className={styles.formGroup}>
            <label>Duration</label>
            <input 
              className={styles.formInput} 
              name="duration" 
              placeholder="e.g. 3 to 7 days" 
              value={form.duration} 
              onChange={handleChange} 
              required 
            />
          </div>
          <div className={styles.formGroup}>
            <label>Icon</label>
            <select 
              className={styles.formInput} 
              name="iconName" 
              value={form.iconName} 
              onChange={handleChange}
            >
              {iconOptions.map(icon => <option key={icon} value={icon}>{icon}</option>)}
            </select>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button type="submit" className={styles.primaryBtn} disabled={loading}>
            {loading ? 'Saving...' : <><FaSave /> {form.id === 0 ? 'Add Step' : 'Update Step'}</>}
          </button>
          {form.id !== 0 && (
            <button type="button" onClick={resetForm} style={{ background: '#64748b', border: 'none', color: 'white', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer' }}>
              Cancel
            </button>
          )}
        </div>
      </form>

      {/* --- LIST SECTION --- */}
      <div>
        <h4 style={{ color: '#fff', marginBottom: '15px' }}>Current Steps ({steps.length})</h4>
        <div style={{ display: 'grid', gap: '15px' }}>
          {steps.map((step) => (
            <div 
              key={step.id} 
              style={{ 
                background: 'rgba(255,255,255,0.05)', 
                padding: '15px', 
                borderRadius: '8px', 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                borderLeft: '4px solid #00D084' 
              }}
            >
              <div>
                <h5 style={{ margin: '0 0 5px 0', color: 'white', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ background: '#00D084', color: '#fff', padding: '2px 8px', borderRadius: '4px', fontSize: '0.8rem' }}>
                    {step.stepNumber}
                  </span>
                  {step.title}
                </h5>
                <p style={{ margin: '0', fontSize: '0.9rem', color: '#cbd5e1' }}>{step.description}</p>
                <small style={{ color: '#94a3b8', display: 'block', marginTop: '5px' }}>
                  ⏱ Duration: {step.duration} | Icon: {step.iconName}
                </small>
              </div>
              
              <div style={{ display: 'flex', gap: '10px' }}>
                <button 
                  onClick={() => handleEdit(step)} 
                  style={{ background: 'transparent', border: 'none', color: '#4ade80', cursor: 'pointer', fontSize: '1.1rem' }}
                  title="Edit"
                >
                  <FaEdit />
                </button>
                <button 
                  onClick={() => handleDelete(step.id)} 
                  style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '1.1rem' }}
                  title="Delete"
                >
                  <FaTrash />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminProcessSteps;